import { v4 as uuidv4 } from 'uuid';

export const errorsList = [
    { id: uuidv4(), message: 'Verifique o código digitado' },
    { id: uuidv4(), message: 'Tente enviar o código novamente' },
]